module.exports = __webpack_public_path__ + "assets/img/sabc_social_instagram.svg?c722d120d0de8a2dc755d650869c32dd";